import axios from "axios";
import { API_BASE_URL } from "../config/apiBaseUrl";

const axiosToken = axios.create({
    baseURL: API_BASE_URL
});
export default axiosToken;
